<template>
  <UkiModal :modalId="modalId" title="Переход на платформу" @close="$emit('close')" @ok="$emit('ok')">
    <div class="form-group">
      <label for="rgg-platform">Платформа</label>
      <uki-select-control id="rgg-platform"
                          :model-value="rggPlatformId"
                          :options="rggPlatforms"
                          empty-title="Не выбрана"
                          required="true"
                          text-field="shortName"
                          value-field="id"
                          @update:model-value="value => $emit('update:rggPlatformId', value)"
      />
    </div>
    <div class="form-group">
      <label for="comment">Комментарий</label>
      <textarea id="comment" :value="comment" rows="4" @input="$emit('update:comment', $event.target.value)">
      </textarea>
    </div>
  </UkiModal>
</template>

<script>
import UkiModal from "@/components/UkiModal";
import UkiSelectControl from "@/components/UkiSelectControl";

export default {
  name: "ChangePlatformModal",
  components: {UkiModal, UkiSelectControl},
  props: ["modalId", "rggPlatforms",
    "rggPlatformId", "comment"],
  emits: ["ok", "close", "update:rggPlatformId", "update:comment"]
}
</script>

<style scoped>

</style>